module.exports = __webpack_public_path__ + "static/survival_minutes-619f98eaf21f8a140e0d4c2be6c8f7ae.jpg";